import { WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { QUERY_PAYMENTS_TAXFORM_LIST_PAYER } from "../keys";
import { paymentsService } from "../../../services/payments";
import { useXWingspanExpansion } from "../../../shared/hooks/useXWingspanExpansion";
import { TaxFormType } from "@wingspanhq/payments/dist/interfaces";

interface TaxFormsFilter {
  year: number;
  type?: TaxFormType;
  filter?: {
    recipientSyncEnabled?: boolean;
  };
}

export const usePayerTaxFormsListSize = (
  params: TaxFormsFilter,
  config?: WSQueryConfig<number, WSServiceError>
) => {
  const defaultParams = {
    page: {
      size: 1
    }
  };
  const queryParams = {
    ...defaultParams,
    ...params
  };
  const { year, type, ...otherParams } = queryParams;

  const xWingspanExpansion = useXWingspanExpansion();

  return useWSQuery<number, WSServiceError>(
    [QUERY_PAYMENTS_TAXFORM_LIST_PAYER, { queryParams, xWingspanExpansion }],
    async () => {
      const { summary } = await paymentsService.taxForm.payerList(
        year,
        type,
        xWingspanExpansion,
        {
          ...otherParams
        }
      );
      return summary.listSize;
    },
    config
  );
};
